export const ASK_CLIR_TOPICS = 'ASK_CLIR_TOPICS';
export const ASk_CLIR_TOPICS_DETAILS = 'ASk_CLIR_TOPICS_DETAILS';

export const DIAGNOISIS_TOPIC_LIST = 'DIAGNOISIS_TOPIC_LIST';
export const DIAGNOISIS_TOPICS_DETAILS = 'DIAGNOISIS_TOPICS_DETAILS';
